import { Link } from 'react-router-dom';
import { useScrollAnimation } from '../../hooks/useScrollAnimation';

export default function Footer() {
  const { ref: section1Ref, isVisible: isVisible1 } = useScrollAnimation({ threshold: 0.1 });
  const { ref: section2Ref, isVisible: isVisible2 } = useScrollAnimation({ threshold: 0.1 });
  const { ref: section3Ref, isVisible: isVisible3 } = useScrollAnimation({ threshold: 0.1 });
  const { ref: section4Ref, isVisible: isVisible4 } = useScrollAnimation({ threshold: 0.1 });

  return (
    <footer className="bg-primary text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div ref={section1Ref as React.RefObject<HTMLDivElement>} className={`${isVisible1 ? 'animate-fade-in-up' : 'opacity-0-init'}`}>
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 bg-secondary rounded-lg flex items-center justify-center">
                <i className="ri-shield-cross-line text-2xl text-white"></i>
              </div>
              <div className="flex flex-col">
                <span className="font-heading text-xl font-bold whitespace-nowrap">Dallas Health Insurance</span>
                <span className="text-xs text-lightBlue whitespace-nowrap">Experts</span>
              </div>
            </div>
            <p className="text-gray-300 text-sm leading-relaxed mb-4">
              Your trusted partner for personalized health insurance solutions in Dallas, Texas. We help individuals, families, and businesses find the right coverage.
            </p>
            <div className="flex gap-4">
              <a href="#" className="w-10 h-10 bg-secondary/20 rounded-full flex items-center justify-center hover:bg-secondary transition-all hover:scale-110 cursor-pointer">
                <i className="ri-facebook-fill text-secondary hover:text-white"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-secondary/20 rounded-full flex items-center justify-center hover:bg-secondary transition-all hover:scale-110 cursor-pointer">
                <i className="ri-linkedin-fill text-secondary hover:text-white"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-secondary/20 rounded-full flex items-center justify-center hover:bg-secondary transition-all hover:scale-110 cursor-pointer">
                <i className="ri-twitter-x-line text-secondary hover:text-white"></i>
              </a>
            </div>
          </div>

          <div ref={section2Ref as React.RefObject<HTMLDivElement>} className={`${isVisible2 ? 'animate-fade-in-up animation-delay-100' : 'opacity-0-init'}`}>
            <h4 className="font-heading text-lg font-semibold mb-6 text-secondary">Quick Links</h4>
            <ul className="space-y-3">
              <li><Link to="/" className="text-gray-300 hover:text-secondary transition-colors cursor-pointer">Home</Link></li>
              <li><Link to="/insurance-plans" className="text-gray-300 hover:text-secondary transition-colors cursor-pointer">Insurance Plans</Link></li>
              <li><Link to="/about" className="text-gray-300 hover:text-secondary transition-colors cursor-pointer">About Us</Link></li>
              <li><Link to="/testimonials" className="text-gray-300 hover:text-secondary transition-colors cursor-pointer">Testimonials</Link></li>
              <li><Link to="/contact" className="text-gray-300 hover:text-secondary transition-colors cursor-pointer">Contact Us</Link></li>
            </ul>
          </div>

          <div ref={section3Ref as React.RefObject<HTMLDivElement>} className={`${isVisible3 ? 'animate-fade-in-up animation-delay-200' : 'opacity-0-init'}`}>
            <h4 className="font-heading text-lg font-semibold mb-6 text-secondary">Insurance Plans</h4>
            <ul className="space-y-3">
              <li><a href="#" className="text-gray-300 hover:text-secondary transition-colors cursor-pointer">Individual & Family Plans</a></li>
              <li><a href="#" className="text-gray-300 hover:text-secondary transition-colors cursor-pointer">Group Health Insurance</a></li>
              <li><a href="#" className="text-gray-300 hover:text-secondary transition-colors cursor-pointer">Medicare Supplement</a></li>
              <li><a href="#" className="text-gray-300 hover:text-secondary transition-colors cursor-pointer">Short-Term Health Plans</a></li>
              <li><a href="#" className="text-gray-300 hover:text-secondary transition-colors cursor-pointer">Free Consultation</a></li>
            </ul>
          </div>

          <div ref={section4Ref as React.RefObject<HTMLDivElement>} className={`${isVisible4 ? 'animate-fade-in-up animation-delay-300' : 'opacity-0-init'}`}>
            <h4 className="font-heading text-lg font-semibold mb-6 text-secondary">Contact Info</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <i className="ri-map-pin-line text-secondary text-xl mt-1"></i>
                <span className="text-gray-300 text-sm">8300 Douglas Ave Ste 800<br />Dallas, TX 75225</span>
              </li>
              <li className="flex items-center gap-3">
                <i className="ri-phone-line text-secondary text-xl"></i>
                <a href="tel:+12143060121" className="text-gray-300 hover:text-secondary transition-colors cursor-pointer">(214) 306-0121</a>
              </li>
              <li className="flex items-center gap-3">
                <i className="ri-mail-line text-secondary text-xl"></i>
                <a href="mailto:info@dallashealthinsurance.com" className="text-gray-300 hover:text-secondary transition-colors cursor-pointer">info@dallashealthinsurance.com</a>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-time-line text-secondary text-xl mt-1"></i>
                <span className="text-gray-300 text-sm">Office Hours<br />Mon-Fri, 8am-6pm</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-400 text-sm">
            © 2024 Dallas Health Insurance Experts. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm">
            <a href="#" className="text-gray-400 hover:text-secondary transition-colors cursor-pointer">Privacy Policy</a>
            <a href="#" className="text-gray-400 hover:text-secondary transition-colors cursor-pointer">Terms of Service</a>
            <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-secondary transition-colors cursor-pointer">Powered by Readdy</a>
          </div>
        </div>
      </div>
    </footer>
  );
}